<svg
  width="24"
  height="24"
  class="shrink-0"
  viewBox="0 0 24 24">
  <use class="fill-current" [attr.xlink:href]="icon()"></use>
</svg>
@if (label(); as label) {
  <span>{{ label }}</span>
}
